import { PERMISSIONS } from '@/config/permissions';

const SP_ORDERS = {
  LIST: 0,
  EXPENSE: 1,
  MY_ACCOUNT: 2,
  STATISTIC: 3,
  MARKET: 4,
  ACCOUNTS: 5,
  STOCK: 6,
  SIGN_OUT: 7,
};

const routes = [
  {
    to: '/bill',
    text: 'TẠO ĐƠN',
    roles: ['admin', 'manager', 'staff'],
    pc: true,
    sp: false,
  },
  {
    to: '/list',
    text: 'DANH SÁCH ĐƠN',
    roles: ['admin', 'manager', 'staff'],
    pc: true,
    sp: true,
    spOrder: SP_ORDERS.LIST,
  },
  {
    to: '/expense',
    text: 'CHI',
    roles: [],
    permissions: [PERMISSIONS.VIEW_QT_EXPENSE],
    pc: true,
    sp: true,
    spOrder: SP_ORDERS.EXPENSE,
  },
  {
    to: '/note',
    text: 'GHI CHÚ',
    roles: ['admin', 'manager', 'staff'],
    pc: true,
    sp: false,
  },
  {
    to: '/market',
    actualTo: '/market#detail',
    text: 'QUẢNG CÁO',
    roles: ['admin', 'manager', 'marketter'],
    pc: true,
    sp: true,
    spOrder: SP_ORDERS.MARKET,
  },
  {
    to: '/stock',
    text: 'KHO HÀNG',
    roles: ['admin', 'manager', 'staff'],
    pc: true,
    sp: true,
    spOrder: SP_ORDERS.STOCK,
  },
  {
    to: '/accounts',
    text: 'QUẢN LÝ TÀI KHOẢN',
    roles: ['admin', 'manager'],
    pc: false,
    sp: true,
    spOrder: SP_ORDERS.ACCOUNTS,
  },
];

const routesUser = [
  {
    to: '/my-account',
    text: 'Thông tin tài khoản',
    roles: ['admin', 'manager', 'marketter', 'staff'],
    pc: true,
    sp: true,
    spOrder: SP_ORDERS.MY_ACCOUNT,
  },
  {
    to: '/statistic',
    text: 'Thống kê',
    roles: ['admin', 'manager'],
    pc: true,
    sp: true,
    spOrder: SP_ORDERS.STATISTIC,
  },
  {
    to: '/stock-statistic',
    text: 'Thống kê kho hàng',
    roles: ['manager'],
    pc: true,
    sp: false,
  },

  {
    to: '/settings',
    text: 'Cài đặt',
    roles: ['admin', 'manager'],
    pc: true,
    sp: false,
  },
  {
    to: '/sign-out',
    text: 'Đăng xuất',
    roles: ['admin', 'manager', 'marketter', 'staff'],
    pc: true,
    sp: true,
    spOrder: SP_ORDERS.SIGN_OUT,
  },
];

// PC uses separate main/account menus; SP combines them in spOrder.
const createNavbarItems = (user) => {
  if (!user || !user.role)
    return { routes: [], routeSP: [], routeUsers: [] };

  const isVisible = (item) =>
    (item.roles?.length > 0
      ? item.roles.some((role) => user.isRole(role))
      : true) &&
    (item.permissions?.length > 0
      ? item.permissions.every((permission) =>
          user.withPermission(permission),
        )
      : true);

  return {
    routes: routes.filter((item) => item.pc && isVisible(item)),
    routeUsers: routesUser.filter(
      (item) => item.pc && isVisible(item),
    ),
    routeSP: [...routes, ...routesUser]
      .filter((item) => item.sp && isVisible(item))
      .sort((a, b) => a.spOrder - b.spOrder)
      .map((item) => ({ ...item, text: item.text.toUpperCase() })),
  };
};

export default createNavbarItems;
